import { useContext } from "react";
import { UserContext } from "../../../engine/context/User.context";
import { roles } from "../../../utils/constants";
import dayjs from "../../../utils/dayjs";
import { t } from "i18next";

export const miutesMaximumDefault = 361;
let minutesDuration = miutesMaximumDefault * 60;

export const validateTimeBetween = (
  refValidator,
  startKey,
  endKey,
  user,
  isLongDuration = false,
  errorNextDay = true,
) => {
  let restricted = true;
  let semiRestricted = true;

  if (user.subRoles.includes(roles.superAdmin)) {
    restricted = false;
  }

  if ([roles.admin, roles.permanance].includes(user.role)) {
    semiRestricted = false;
  }

  let values = refValidator.getFieldsValue(true);
  let start = values[startKey];
  let end = values[endKey];

  if (start === undefined || end === undefined) {
    return Promise.reject(new Error(t("prestations.errorEmpty")));
  }

  // Calculate the total duration in seconds
  const durationSeconds = end.diff(start, "second");

  if (durationSeconds < 0) {
    return Promise.reject(new Error(t("prestations.errorNegative")));
  }

  if (restricted) {
    let tomorrow = dayjs()
      .add(1, "day")
      .startOf("day"); // On calcule le début de la journée suivante

    // Vérifier que la date de début est pour demain ou plus tard
    if (start.isBefore(tomorrow) && errorNextDay && semiRestricted) {
      return Promise.reject(new Error(t("prestations.errorNextDay")));
    }

    if (isLongDuration) {
      minutesDuration = 28800;
    }

    // Vérifier que la durrée n'est pas plus de 6 heures
    if (durationSeconds >= minutesDuration) {
      return Promise.reject(new Error(t("prestations.errorDuration")));
    }

    if (start.isBefore(tomorrow) && errorNextDay && semiRestricted) {
      return Promise.reject(new Error(t("prestations.errorNextDay")));
    }
  }

  return Promise.resolve();
};

export const disabledDatePast = current => {
  // Rule 1: Not in past
  return current && current < dayjs().endOf("day");
};

export const disabledDateNext12Months = current => {
  // Rule: Disable dates more than 12 months in the future
  return (
    current &&
    current >
      dayjs()
        .add(12, "month")
        .endOf("day")
  );
};
